import Vue from 'vue';
import Router from 'vue-router';
import MobilePage from '../components/MobilePage.vue';
import PcPage from '../components/PcPage.vue';
import PrivatePolicy from '../components/PrivatePolicy.vue';

Vue.use(Router);

// 1. 先创建 router 实例
const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/private-policy',
            name: 'privacy',
            component: PrivatePolicy
        },
        {
            path: '/mobile',
            name: 'mobile',
            component: MobilePage
        },
        {
            path: '/pc',
            name: 'pc',
            component: PcPage
        },
    ]
});

// 2. 再定义全局路由守卫（此时 router 已初始化）
router.beforeEach((to, from, next) => {
    if (to.path === '/private') {
        next();
        return;
    }
    const deviceType = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        ? 'mobile'
        : 'pc';
    if (to.path === '/') {
        next({ name: deviceType });
    } else {
        next();
    }
});

export default router;